var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconPoweredByHearXFrenchLight } from 'hx-assets';
import { Typography } from '@mui/material';
import { cn } from 'hx-util';
export function WelcomeFooter(_a) {
    var className = _a.className;
    return (_jsxs("div", __assign({ className: cn('flex flex-col items-center gap-3', className) }, { children: [_jsx(Typography, __assign({ variant: "caption", className: "w-full max-w-[384px] px-6 text-center" }, { children: "*Test auditif valid\u00E9 (International Journal of Audiology, 2016; Ear and Hearing, 2018)." })), _jsx(IconPoweredByHearXFrenchLight, { className: "w-full max-w-[384px] h-4" })] })));
}
